import styled from 'styled-components';
import { Cover } from 'ui-toolkit/index';

export const CoverOnTop = styled(Cover)`
  z-index: 10;
`;
